import type { SelectionContext } from '@nfa/types';

interface SelectionContextPanelProps {
  context: SelectionContext;
}

export function SelectionContextPanel({ context }: SelectionContextPanelProps) {
  return (
    <div className="bg-neutral-900 border border-neutral-800 rounded-xl p-5 mb-8">
      {/* Query Summary */}
      <p className="text-lg text-white font-medium mb-4">
        {context.query_summary}
      </p>

      <div className="grid gap-6 sm:grid-cols-2">
        {/* Key Considerations */}
        <div>
          <h4 className="text-xs text-neutral-500 uppercase tracking-wider mb-3 flex items-center gap-2">
            <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Key Considerations
          </h4>
          <ul className="space-y-2">
            {context.key_considerations.map((consideration, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-neutral-300">
                <span className="text-orange-500 mt-0.5">•</span>
                <span>{consideration}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Gear Priorities */}
        <div>
          <h4 className="text-xs text-neutral-500 uppercase tracking-wider mb-3 flex items-center gap-2">
            <svg className="w-4 h-4 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Gear Priorities
          </h4>
          <ul className="space-y-2">
            {context.gear_priorities.map((priority, i) => (
              <li key={i} className="flex items-start gap-2 text-sm text-neutral-300">
                <span className="text-cyan-500 mt-0.5">•</span>
                <span>{priority}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
